import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const companyRequest = createRequest(constants.company);
export const companySuccess = createSuccess(constants.company);
export const companyFailure = createFailure(constants.company);

export const enableVisitorLogRequest = createRequest(constants.enableVisitorLog);
export const enableVisitorLogSuccess = createSuccess(constants.enableVisitorLog);
export const enableVisitorLogFailure = createFailure(constants.enableVisitorLog);

export const disableVisitorLogRequest = createRequest(constants.disableVisitorLog);
export const disableVisitorLogSuccess = createSuccess(constants.disableVisitorLog);
export const disableVisitorLogFailure = createFailure(constants.disableVisitorLog);

export const enableSSORequest = createRequest(constants.enableSSO);
export const enableSSOSuccess = createSuccess(constants.enableSSO);
export const enableSSOFailure = createFailure(constants.enableSSO);

export const disableSSORequest = createRequest(constants.disableSSO);
export const disableSSOSuccess = createSuccess(constants.disableSSO);
export const disableSSOFailure = createFailure(constants.disableSSO);

export const updateSSOConfigurationRequest = createRequest(constants.updateSSOConfiguration);
export const updateSSOConfigurationSuccess = createSuccess(constants.updateSSOConfiguration);
export const updateSSOConfigurationFailure = createFailure(constants.updateSSOConfiguration);

export const ssoConfigurationRequest = createRequest(constants.ssoConfiguration);
export const ssoConfigurationSuccess = createSuccess(constants.ssoConfiguration);
export const ssoConfigurationFailure = createFailure(constants.ssoConfiguration);

export const enableBranchesRequest = createRequest(constants.enableBranches);
export const enableBranchesSuccess = createSuccess(constants.enableBranches);
export const enableBranchesFailure = createFailure(constants.enableBranches);

export const disableBranchesRequest = createRequest(constants.disableBranches);
export const disableBranchesSuccess = createSuccess(constants.disableBranches);
export const disableBranchesFailure = createFailure(constants.disableBranches);

export const requestCompany = companyRequest;
export const enableVisitorLog = enableVisitorLogRequest;
export const disableVisitorLog = disableVisitorLogRequest;
export const enableSSO = enableSSORequest;
export const disableSSO = disableSSORequest;
export const updateSSOConfiguration = updateSSOConfigurationRequest;
export const requestSSOConfiguration = ssoConfigurationRequest;
export const enableBranches = enableBranchesRequest;
export const disableBranches = disableBranchesRequest;
